"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIndexHelper = exports.zIndexCssClassType = void 0;
var zIndexCssClassType;
(function (zIndexCssClassType) {
    zIndexCssClassType[zIndexCssClassType["TextBoxBg"] = 0] = "TextBoxBg";
    zIndexCssClassType[zIndexCssClassType["TblRowBg"] = 1] = "TblRowBg";
    zIndexCssClassType[zIndexCssClassType["TblCellBg"] = 2] = "TblCellBg";
    zIndexCssClassType[zIndexCssClassType["ParBg"] = 3] = "ParBg";
    zIndexCssClassType[zIndexCssClassType["BoxBg"] = 4] = "BoxBg";
    zIndexCssClassType[zIndexCssClassType["FieldBg"] = 5] = "FieldBg";
    zIndexCssClassType[zIndexCssClassType["SelRange"] = 6] = "SelRange";
    zIndexCssClassType[zIndexCssClassType["BoxSpace"] = 7] = "BoxSpace";
    zIndexCssClassType[zIndexCssClassType["SelSearch"] = 8] = "SelSearch";
    zIndexCssClassType[zIndexCssClassType["SelRow"] = 9] = "SelRow";
    zIndexCssClassType[zIndexCssClassType["Box"] = 10] = "Box";
    zIndexCssClassType[zIndexCssClassType["Bookmark"] = 11] = "Bookmark";
    zIndexCssClassType[zIndexCssClassType["TableBorder"] = 12] = "TableBorder";
    zIndexCssClassType[zIndexCssClassType["SelMissp"] = 13] = "SelMissp";
    zIndexCssClassType[zIndexCssClassType["SelCursor"] = 14] = "SelCursor";
    zIndexCssClassType[zIndexCssClassType["SelTouchBar"] = 15] = "SelTouchBar";
    zIndexCssClassType[zIndexCssClassType["TblCursor"] = 16] = "TblCursor";
    zIndexCssClassType[zIndexCssClassType["AnchoredPicture"] = 17] = "AnchoredPicture";
    zIndexCssClassType[zIndexCssClassType["TextBox"] = 18] = "TextBox";
})(zIndexCssClassType = exports.zIndexCssClassType || (exports.zIndexCssClassType = {}));
var ZIndexHelper = (function () {
    function ZIndexHelper() {
    }
    ZIndexHelper.getClassName = function (level, zIndexCssNames) {
        return "dxre" + ZIndexHelper.names[zIndexCssNames] + "ZL" + level;
    };
    ZIndexHelper.names = (_a = {},
        _a[zIndexCssClassType.TextBoxBg] = "TextBoxBg",
        _a[zIndexCssClassType.TblRowBg] = "TblRowBg",
        _a[zIndexCssClassType.TblCellBg] = "TblCellBg",
        _a[zIndexCssClassType.ParBg] = "ParBg",
        _a[zIndexCssClassType.BoxBg] = "BoxBg",
        _a[zIndexCssClassType.FieldBg] = "FieldBg",
        _a[zIndexCssClassType.SelRange] = "SelRange",
        _a[zIndexCssClassType.BoxSpace] = "BoxSpace",
        _a[zIndexCssClassType.SelSearch] = "SelSearch",
        _a[zIndexCssClassType.SelRow] = "SelRow",
        _a[zIndexCssClassType.Box] = "Box",
        _a[zIndexCssClassType.Bookmark] = "Bookmark",
        _a[zIndexCssClassType.TableBorder] = "TableBorder",
        _a[zIndexCssClassType.SelMissp] = "SelMissp",
        _a[zIndexCssClassType.SelCursor] = "SelCursor",
        _a[zIndexCssClassType.SelTouchBar] = "SelTouchBar",
        _a[zIndexCssClassType.TblCursor] = "TblCursor",
        _a[zIndexCssClassType.AnchoredPicture] = "AnchoredPicture",
        _a[zIndexCssClassType.TextBox] = "TextBox",
        _a);
    return ZIndexHelper;
}());
exports.ZIndexHelper = ZIndexHelper;
